export const PREPARE_REQUIRED_FIELDS = [
  'widthTop',
  'widthMiddle',
  'widthBottom',
  'heightLeft',
  'heightMiddle',
  'heightRight',
  'runOutDirection',
  'runOutAmount'
];

export const PREPARE_FIELD_LABELS = {
  widthTop: 'Top Width',
  widthMiddle: 'Middle Width',
  widthBottom: 'Bottom Width',
  heightLeft: 'Left Height',
  heightMiddle: 'Middle Height',
  heightRight: 'Right Height',
  runOutDirection: 'Run-out Direction',
  runOutAmount: 'Run-out Amount'
};

export const TILE_TYPE_OPTIONS = [
  { id: 'image', title: 'Image' },
  { id: 'mod', title: 'Mod' }
];

export const RUN_OUT_DIRECTION_OPTIONS = [
  { id: 'Left', title: 'Left' },
  { id: 'Right', title: 'Right' }
];

function hasPrepareValue(value) {
  return value !== null && value !== undefined && value !== '';
}

export function isPrepareComplete(prepareItem, usesStandardLevels) {
  if (!prepareItem) return false;
  if (usesStandardLevels) return true;
  return PREPARE_REQUIRED_FIELDS.every((field) => hasPrepareValue(prepareItem.item.specs[field]));
}

export function prepareFieldErrors(prepareItem, usesStandardLevels) {
  if (!prepareItem || usesStandardLevels) return [];
  const itemKey = prepareItem.item.id ?? prepareItem.item.ref;
  return Object.keys(PREPARE_FIELD_LABELS).reduce((errors, field) => {
    if (!hasPrepareValue(prepareItem.item.specs[field])) {
      errors.push({
        handle: `prepare-${itemKey}-${field}`,
        message: `${PREPARE_FIELD_LABELS[field]} is required`
      });
    }
    return errors;
  }, []);
}
